/* eslint-disable */
var minimatch = require('minimatch')

var toRegExp = function(pattern) {
  var i = pattern.indexOf('/')

  if (i === -1 || i === pattern.length-1) {
    pattern = minimatch.makeRe(pattern, {dot:true}).toString()
      .replace(/^\/\^/, '/(^|\\/)')
      .replace(/\$\/$/, '($|\\/)/')
    return new RegExp(pattern.slice(1,-1), 'i')
  }

  if (i === 0) pattern = pattern.slice(1)

  return minimatch.makeRe(pattern, {dot:true, nocase:true})
}

var falsy = function() {
  return false
}

var toFunction = function(regexp) {
  return function(input) {
    return regexp.test(input)
  }
}

var or = function(a, b) {
  if (a === falsy) return b
  return function(input) {
    return a(input) || b(input)
  }
}

export default class IgnoreFile{
  constructor(src) {
    if (Array.isArray(src)) src = src.join('\n')

    var lines = src.split('\n')
      .map(function(line) {
        return line.trim()
      })
      .filter(function(line) {
        return line && line[0] !== '#'
      })

    this.negative = lines
      .filter(function(line) {
        return line[0] !== '!'
      })
      .map(toRegExp)
      .map(toFunction)
      .reduce(or, falsy);

    this.positive = lines
      .filter(function(line) {
        return line[0] === '!'
      })
      .map(function(line) {
        return line.slice(1)
      })
      .map(toRegExp)
      .map(toFunction)
      .reduce(or, falsy);
  }

  isToIgnore(input){
    return !this.positive(input) && this.negative(input);
  }
}
